import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import DeleteIcon from "@mui/icons-material/Delete";
import { listRecordMine, deleteRecord } from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import { RECORD_DELETE_RESET } from "../constants/financeConstants";
import Notification from "../components/Notification";
import ConfirmDialog from "../components/ConfirmDialog";
import { ExportToExcel } from "../components/ExportToExcel";

export default function RecordListScreen(props) {
  const fileName = "RecordList" + new Date();
  const recordMineList = useSelector((state) => state.recordMineList);
  const { loading, summary, error } = recordMineList;

  //const records = recordsList.Records;
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const navigate = useNavigate();
  const recordDelete = useSelector((state) => state.recordDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = recordDelete;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: RECORD_DELETE_RESET });
    dispatch(listRecordMine());
  }, [dispatch, successDelete]);

  console.log("summary:" + summary);
  const onDelete = (record) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    // if (window.confirm('Are you sure to delete?')) {
    dispatch(deleteRecord(record._id));
    setNotify({
      isOpen: true,
      message: "Records Deleted Successfully",
      type: "success",
    });

    // }
  };

  return (
    <div>
      <h1>Record List</h1>

      <h5>
        <button type="button" className="small">
          <Link to="/addfinancerec">Input Finance Record</Link>
        </button>
      </h5>
      {loadingDelete && <LoadingBox></LoadingBox>}
      {errorDelete && <MessageBox variant="danger">{errorDelete}</MessageBox>}
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <ExportToExcel apiData={summary.Records} fileName={fileName} />
          <ul className="row summary">
            <li>
              <div className="summary-title color2">
                <span>
                  <i className="fa fa-shopping-cart" /> Total Records
                </span>
              </div>
              <div className="summary-body">
                {summary.recordsSum[0] ? summary.recordsSum[0].numRecords : 0}
              </div>
            </li>
            <li>
              <div className="summary-title color3">
                <span>
                  <i className="fa fa-money" /> Expense
                </span>
              </div>
              <div className="summary-body">
                $
                {summary.recordsSum[0]
                  ? summary.recordsSum[0].totalExpense.toFixed(2)
                  : 0}
              </div>
            </li>
          </ul>
          <table className="table">
            <thead>
              <tr>
                <th>Record ID</th>
                <th>Description</th>
                <th>Invoice Amount</th>
                <th>Currency</th>
                <th>Category</th>
                <th>Inoivce file</th>
                <th>Payment Method</th>
                <th>Payment Date</th>
                <th>Paid by whom</th>
                <th>Paid to whom</th>
                <th>other information</th>
                <th>new Paydate</th>
              </tr>
            </thead>

            <tbody>
              {summary.Records.map((record) => (
                <tr key={record._id}>
                  <td>{record._id}</td>
                  <td>{record.description}</td>
                  <td>
                    {/* 
                {record.invoiceamount.toFixed(2)}
                */}
                    <CurrencyFormat
                      value={record.invoiceamount}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </td>
                  <td>{record.currency}</td>
                  <td>{record.category}</td>
                  <td>{record.inoivcefile}</td>
                  <td>{record.paymentmethod}</td>
                  <td>{record.paymentdate}</td>
                  <td>{record.payby}</td>
                  <td>{record.payto}</td>
                  <td>{record.otherinfo}</td>
                  <td>{record.paydate}</td>
                  <td>
                    <button
                      type="button"
                      className="small"
                      onClick={() => navigate(`/records/${record._id}/edit`)}
                    >
                      Edit
                    </button>
                    {/* 
                                      <button
                    type="button"
                    className="small"
                    onClick={() => {
                      props.history.push(`/record/${record._id}`);
                    }}
                  >
                    Details
                  </button>
                    
                    
                    */}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="small"
                      onClick={() => {
                        setConfirmDialog({
                          isOpen: true,
                          title: "Are you sure to delete the record?",
                          subTitle:
                            "You can't UNDO this operation once you click YES!",
                          onConfirm: () => {
                            onDelete(record);
                          },
                        });
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      <Notification notify={notify} setNotify={setNotify}></Notification>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
}
